import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useRef } from 'react';
import { any, bool, func, node, oneOf, oneOfType, shape, string } from 'prop-types';
import { usePopper } from 'react-popper';
import { Container } from './popper.styles';
import Box from '../Box';

function Popper(_ref) {
  let {
    backgroundColor,
    children,
    parentRef,
    placement = 'bottom',
    visible
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["backgroundColor", "children", "parentRef", "placement", "visible"]);

  const [arrowRef, setArrowRef] = useState(null);
  const popperRef = useRef(null);
  const {
    styles,
    attributes
  } = usePopper(parentRef.current, popperRef.current, {
    placement,
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowRef
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }, {
      name: 'flip',
      options: {
        flipVariations: false
      }
    }]
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, visible ? /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "popper-container",
    ref: popperRef,
    style: styles.popper
  }, attributes.popper, {
    backgroundColor: backgroundColor
  }, props), /*#__PURE__*/React.createElement("div", {
    ref: setArrowRef,
    style: styles.arrow,
    id: "arrow"
  }), /*#__PURE__*/React.createElement(Box, {
    "data-testid": "popper-children-container",
    m: 1
  }, children)) : null);
}

process.env.NODE_ENV !== "production" ? Popper.propTypes = {
  backgroundColor: string,
  children: node.isRequired,
  parentRef: oneOfType([func, shape({
    current: any
  })]).isRequired,
  placement: oneOf(['bottom', 'top', 'right', 'left']),
  visible: bool
} : void 0;
export default Popper;